export default "__VITE_ASSET__Cgg4l9LR__"